import { inject, Injectable, PLATFORM_ID, TransferState } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Observable, of, switchMap } from 'rxjs';

import {
  BaseSite, Config, ConfigInitializerService, LANGUAGE_CONTEXT_ID, SiteContextConfig, SiteContextConfigInitializer
} from '@spartacus/core';

import { CUSTOM_BRAND, CUSTOM_LANGUAGE, SERVER_CONFIG, SRV_CONFIG_KEY } from '../../constants';
import { languageToCustom } from '../../services/custom-language.service';
import { CustomBaseStore } from '../../models';

@Injectable()
export class CustomSiteContextConfigInitializer extends SiteContextConfigInitializer {
  private readonly serverConfig?: Config = inject(SERVER_CONFIG, { optional: true });
  private readonly configInitializerService = inject(ConfigInitializerService);
  private readonly platformId: any = inject(PLATFORM_ID);
  private readonly transferState = inject(TransferState);

  protected resolveConfig(): Observable<SiteContextConfig> {
    if (isPlatformServer(this.platformId) && this.serverConfig) {
      this.transferState.set(SRV_CONFIG_KEY, this.serverConfig);
      return of(this.serverConfig);
    }

    if (this.transferState.hasKey(SRV_CONFIG_KEY)) {
      const serverConfig = this.transferState.get(SRV_CONFIG_KEY, undefined);
      this.transferState.remove(SRV_CONFIG_KEY);
      return of(serverConfig);
    }

    return this.configInitializerService.getStable('backend.occ').pipe(
      switchMap(() => super.resolveConfig())
    );
  }

  protected getConfig(source: BaseSite): SiteContextConfig {
    const { houseOfBrandConfig } = source.baseStore as CustomBaseStore;
    const { context } = super.getConfig(source);

    return {
      context: {
        ...context,
        [CUSTOM_LANGUAGE]: context[LANGUAGE_CONTEXT_ID].map(languageToCustom),
        [CUSTOM_BRAND]: houseOfBrandConfig?.brand?.map(({ id }) => id.toLowerCase()) ?? [],
        urlParameters: context.urlParameters
      }
    };
  }
}
